import { Injectable } from '@angular/core';
import {Http, Headers} from '@angular/http';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';
import {Service} from "../../shared/services/service";
import {Funcoes} from "../../funcoes";

@Injectable()
export class ClientesLaudosTecnicosService extends Service{

  protected url: string = this.dominio+"/cli/clientes-usuarios/meus-laudos-tecnicos/";

  constructor(protected http: Http, protected func: Funcoes) {
    super();
  }

  // busca lista de clientes visiveis para o usuario logado
  getVisibilidades() {
    let headers = this.getHeaderLogado();

    return this.http.get(this.url + 'visibilidades/', { headers })
      .map(res => {
        let json = res.json();
        if (json.Success) {
          this.trataSucesso(res);
        } else {
          this.trataErro(json);
        }
        return json;
      });
  }

  enviaPdfEmail(id, elem){
    let headers = this.getHeaderLogado();

    return this.http.post(this.url + id+'/notificar', JSON.stringify(elem),{headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  // baixa o zip individual com o pdf do laudo tecnico
  baixarZipPdf(id){
    let headers = this.getHeaderLogado();

    return this.http.get(this.url + id+'/download-zip/', {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

}




// WEBPACK FOOTER //
// ./src/app/area-cliente/meus-laudos-tecnicos/clientes-laudos-tecnicos.service.ts